import React, { useState, useEffect } from "react";
import contactImage1 from "../../assets/images/users/user-1.jpg";
import penImage from "../../assets/images/DeathModuleNew/edit.png";
import penIcon from "../../assets/images/DeathModuleNew/penWhite.svg";
import DEATH_API from "../../apis/death.api";
import Loader from "../../components/styled-components/loader/loader";
import axios from "axios";
import { MODULE_API } from "../../apis";
import { Select, Radio } from "antd";
import PhoneNumber from "../../components/form/components/Countrycode";
import { ToolTipCreator } from "../../helpers/ToolTipCreator";
const { Option } = Select;

export const UpdateClinetContacts = (props) => {
  const [formData, setFormData] = useState(props && props.contact);
  const [loading, setLoading] = useState(false);
  const [groups, setGroups] = useState([]);
  console.log("props groups", props.groups);
  console.log("props.contact", props.contact);

  // address Dynamic fields
  const [addressField, setAddressField] = useState({ address: [] });
  const addAddressField = () => {
    setAddressField((prevState) => ({
      ...prevState,
      address: [...prevState.address, { fieldName: "", fieldValue: "", heading: "Address" }],
    }));
  };
  const removeAddressField = (index) => {
    const updatedAddress = [...addressField.address];
    updatedAddress.splice(index, 1);
    setAddressField((prevState) => ({
      ...prevState,
      address: updatedAddress,
    }));
  };
  const handleAddressChange = (index, fieldName, value) => {
    setAddressField((prevState) => ({
      ...prevState,
      address: prevState.address.map((item, idx) => {
        if (idx === index) {
          return { ...item, [fieldName]: value };
        }
        return item;
      }),
    }));
  };

  // email Dynamic fields
  const [emailsField, setEmailsField] = useState({ emails: [] });
  const addEmailField = () => {
    setEmailsField((prevState) => ({
      ...prevState,
      emails: [...prevState.emails, { fieldName: "", fieldValue: "", heading: "Email" }],
    }));
  };
  const removeEmailField = (index) => {
    const updatedEmails = [...emailsField.emails];
    updatedEmails.splice(index, 1);
    setEmailsField((prevState) => ({
      ...prevState,
      emails: updatedEmails,
    }));
  };
  const handleEmailsChange = (index, fieldName, value) => {
    const updatedEmails = [...emailsField.emails];
    updatedEmails[index][fieldName] = value;
    setEmailsField((prevState) => ({
      ...prevState,
      emails: updatedEmails,
    }));
  };
  // phone dynamic fields
  const [phoneField, setPhoneField] = useState({ phone: [] });
  const addPhoneField = () => {
    setPhoneField((prevState) => ({
      ...prevState,
      phone: [...prevState.phone, { fieldName: "", fieldValue: "", heading: "Phone" }],
    }));
  };
  const removePhoneField = (index) => {
    const updatedPhone = [...phoneField.phone];
    updatedPhone.splice(index, 1);
    setPhoneField((prevState) => ({
      ...prevState,
      phone: updatedPhone,
    }));
  };
  const handlePhoneChange = (index, fieldName, value) => {
    const updatedPhone = [...phoneField.phone];
    updatedPhone[index][fieldName] = value;
    setPhoneField((prevState) => ({
      ...prevState,
      phone: updatedPhone,
    }));
  };
  // social dynamic fields
  const [socialField, setSocialField] = useState({ social: [] });
  const addSocialField = () => {
    setSocialField((prevState) => ({
      ...prevState,
      social: [...prevState.social, { fieldName: "", fieldValue: "", heading: "Social" }],
    }));
  };
  const removeSocialField = (index) => {
    const updatedSocial = [...socialField.social];
    updatedSocial.splice(index, 1);
    setSocialField((prevState) => ({
      ...prevState,
      social: updatedSocial,
    }));
  };
  const handleSocialChange = (index, fieldName, value) => {
    const updatedSocial = [...socialField.social];
    updatedSocial[index][fieldName] = value;
    console.log("socialField", socialField);
    setSocialField((prevState) => ({
      ...prevState,
      social: updatedSocial,
    }));
  };

  // web dynamic fields
  const [webField, setWebField] = useState({ web: [] });
  const addWebField = () => {
    setWebField((prevState) => ({
      ...prevState,
      web: [...prevState.web, { fieldName: "", fieldValue: "", heading: "Web" }],
    }));
  };
  const removeWebField = (index) => {
    const updatedWeb = [...webField.web];
    updatedWeb.splice(index, 1);
    setWebField((prevState) => ({
      ...prevState,
      web: updatedWeb,
    }));
  };
  const handleWebChange = (index, fieldName, value) => {
    const updatedWeb = [...webField.web];
    updatedWeb[index][fieldName] = value;
    console.log("socialField", webField);
    setWebField((prevState) => ({
      ...prevState,
      web: updatedWeb,
    }));
  };

  // date dynamic fields
  const [dateField, setDateField] = useState({ date: [] });
  const addDateField = () => {
    setDateField((prevState) => ({
      ...prevState,
      date: [...prevState.date, { fieldName: "", fieldValue: "", heading: "Date" }],
    }));
  };
  const removeDateField = (index) => {
    const updatedDate = [...dateField.date];
    updatedDate.splice(index, 1);
    setDateField((prevState) => ({
      ...prevState,
      date: updatedDate,
    }));
  };
  const handleDateChange = (index, fieldName, value) => {
    const updatedDate = [...dateField.date];
    updatedDate[index][fieldName] = value;
    console.log("socialField", dateField);
    setDateField((prevState) => ({
      ...prevState,
      date: updatedDate,
    }));
  };

  const handleDynamicChange = (heading, fieldName, value) => {
    // Find the index of the existing field with the same fieldName
    const existingIndex = (formData.dynamicDetails || []).findIndex(
      (detail) => detail.heading === heading && detail.fieldName === fieldName
    );

    // If the field already exists, update its value
    if (existingIndex !== -1) {
      setFormData((prevFormData) => ({
        ...prevFormData,
        dynamicDetails: (prevFormData.dynamicDetails || []).map((detail, index) => {
          if (index === existingIndex) {
            return {
              ...detail,
              fieldValue: value,
            };
          }
          return detail;
        }),
      }));
    } else {
      // Otherwise, add a new field
      const newField = {
        heading: heading,
        fieldName: fieldName,
        fieldValue: value,
      };
      console.log("newField", newField);
      // Update the formData state
      setFormData((prevFormData) => ({
        ...prevFormData,
        dynamicDetails: [...(prevFormData.dynamicDetails || []), newField],
      }));
    }
  };
  const handleDynamicAddressChange = (heading, fieldSubType, fieldName, value) => {
    // Find the index of the existing field with the same fieldName and fieldSubType
    const existingIndex = (formData.dynamicDetails || []).findIndex(
      (detail) =>
        detail.heading === heading && detail.fieldName === fieldName && detail.fieldSubType === fieldSubType
    );

    // If the field already exists, update its value
    if (existingIndex !== -1) {
      setFormData((prevFormData) => ({
        ...prevFormData,
        dynamicDetails: (prevFormData.dynamicDetails || []).map((detail, index) => {
          if (index === existingIndex) {
            return {
              ...detail,
              fieldValue: value,
            };
          }
          return detail;
        }),
      }));
    } else {
      // Otherwise, add a new field
      const newField = {
        heading: heading,
        fieldName: fieldName,
        fieldSubType: fieldSubType,
        fieldValue: value,
      };
      // Update the formData state
      setFormData((prevFormData) => ({
        ...prevFormData,
        dynamicDetails: [...(prevFormData.dynamicDetails || []), newField],
      }));
    }
  };

  console.log("formdatatata", formData);

  const handleImageUpload = async (event) => {
    // event.preventDefault();

    const fileSize = event.target.files[0].size / (1024 * 1000); // in MB
    console.log("fileSize in mb", fileSize);
    let uploadFile = event.target.files[0];
    if (uploadFile) {
      const formData = new FormData();
      formData.append("file", uploadFile);
      console.log("item.file", uploadFile);
      const name = uploadFile.name;
      const lastDot = name.lastIndexOf(".");
      const fileName = name.substring(0, lastDot);
      const ext = name.substring(lastDot + 1);
      setLoading(true);
      const resdata = await MODULE_API.uploadFile({
        fileExt: ext,
        contentType: uploadFile.type,
      });
      const resupload = await axios.put(resdata.uploadUrl, uploadFile, {
        headers: { "Content-type": uploadFile.type },
      });
      const res = resdata.uploadUrl.split("?")[0];
      console.log("image", res);
      setLoading(false);
      setFormData((prevFormData) => ({
        ...prevFormData,
        ["image"]: res,
      }));
      // setFormData({
      //   ...formData,
      //   ["image"]: res,
      // });
      // let obj = {
      //   ...formDataProfile,
      //   ["image"]: res,
      // };
      // handleSubmit(obj);
    }
  };

  const handlechange = (name, value) => {
    // e.preventDefault();
    setFormData({
      ...formData,
      [name]: value,
    });
  };
  const getContactsGroup = async () => {
    try {
      setLoading(true);
      let apiResponse = await DEATH_API.getContactGroup(props.contact.id);
      console.log("apiResponse", apiResponse);
      if (apiResponse && apiResponse.groups) {
        const groupNames = apiResponse.groups.map((group) => group.groupName);
        setGroups(groupNames);
      }
      setLoading(false);
    } catch (error) {
      console.log(error);
      setLoading(false);
    }
  };

  useEffect(() => {
    // Check if the URL contains the authorization code
    getContactsGroup();
  }, []);
  const updateCloudContact = async () => {
    console.log("Group Name:", formData);
    let payload = {
      ...formData,
      name: `${formData.prefix ? formData.prefix + " " : ""}${formData.firstName} ${formData.lastName}${
        formData.suffix ? " " + formData.suffix : ""
      }`,
      dynamicDetails: formData.dynamicDetails || [],
    };
    console.log("emailsField inside", emailsField);
    if (formData && emailsField && emailsField.emails.length > 0) {
      payload = {
        ...payload,
        dynamicDetails: [...payload.dynamicDetails, ...emailsField.emails],
      };
    }

    if (formData && phoneField && phoneField.phone.length > 0) {
      payload = {
        ...payload,
        dynamicDetails: [...payload.dynamicDetails, ...phoneField.phone],
      };
    }
    console.log(socialField, "socialField in");
    if (formData && socialField && socialField.social.length > 0) {
      payload = {
        ...payload,
        dynamicDetails: [...payload.dynamicDetails, ...socialField.social],
      };
    }
    if (formData && webField && webField.web.length > 0) {
      payload = {
        ...payload,
        dynamicDetails: [...payload.dynamicDetails, ...webField.web],
      };
    }
    if (formData && dateField && dateField.date.length > 0) {
      payload = {
        ...payload,
        dynamicDetails: [...payload.dynamicDetails, ...dateField.date],
      };
    }
    if (formData && addressField && addressField.address.length > 0) {
      const transformedData = {
        address:
          addressField &&
          addressField.address
            .map((item, index) => {
              return Object.keys(item)
                .filter((key) => key !== "heading" && key !== "fieldValue")
                .map((key) => ({
                  fieldName: key,
                  fieldValue: item[key],
                  heading: item.heading,
                  fieldSubType: addressField.address[index].fieldName,
                }));
            })
            .flat(),
      };
      console.log("transformedData", transformedData);
      payload = {
        ...payload,
        dynamicDetails: [...payload.dynamicDetails, ...transformedData.address],
      };
    }
    try {
      setLoading(true);
      let apiResponse = await DEATH_API.updateCloudContact(props.contact.id, payload);
      console.log("apiResponse", apiResponse);
      if (apiResponse && apiResponse.status === 200) {
        props.close();
        setFormData(null);
      }
      setLoading(false);
    } catch (error) {
      console.log(error);
      setLoading(false);
    }
  };
  const addCloudContact = async () => {
    console.log("Group Name:", formData);
    try {
      setLoading(true);
      let apiResponse = await DEATH_API.updateCloudContact(props.contact.id, formData);
      console.log("apiResponse", apiResponse);
      // if (apiResponse && apiResponse.status===200) {
      //  await getGroups();
      // }
      setLoading(false);
    } catch (error) {
      console.log(error);
      setLoading(false);
    }
  };
  const addGroupCloudContact = async () => {
    console.log("Group Name:", formData);
    const matchingGroupIds =
      groups &&
      groups.map((name) => {
        const matchingGroup = props.groups.find((group) => group.name === name);
        return matchingGroup ? matchingGroup.id : null;
      });
    console.log(matchingGroupIds, "matchingGroupIds");
    try {
      setLoading(true);
      let apiResponse = await DEATH_API.addCloudContactGroup({
        addedContactId: props.contact.id,
        groupIds: matchingGroupIds,
      });
      console.log("apiResponse", apiResponse);
      if (apiResponse && apiResponse.status === 200) {
        //  await getGroups();
      }
      setLoading(false);
    } catch (error) {
      console.log(error);
      setLoading(false);
    }
  };

  const typeOfRelation = [
    "Accounting - CPA",
    "Accounting - Bookkeeper",
    "Child",
    "Consultant",
    "Family",
    "Financial Services - Advisor",
    "Financial Services - Wealth Planner",
    "Financial Services - Insurance Agent Property",
    "Financial Services - Insurance Agent Life",
    "Friend",
    "Health - Doctor",
    "Health - Dentist",
    "Health - Veterinarian",
    "Health - Pharmacist",
    "Lawyer",
    "Professional",
    "Spouse/Partner",
    "Others",
  ];

  return (
    <div
      style={{
        background: "white",
        padding: "1rem",
        marginTop: "1rem",
        borderRadius: "8px",
        height: "calc(100vh - 150px)",
        overflow: "auto",
      }}
    >
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          flexDirection: "column",
          // width: "80%",
        }}
      >
        <div style={{ display: "flex" }}>
          <div className="chatCardInner" style={{ width: "80%" }}>
            {" "}
            <div className="chatCard">
              <input
                type="file"
                id="image"
                name="image"
                onChange={handleImageUpload}
                accept="image/*"
                style={{ display: "none" }}
              />
              <label htmlFor="image" style={{ cursor: "pointer" }}>
                {props.contact.image || (formData && formData.image) ? (
                  <React.Fragment>
                    {formData && formData.image ? (
                      <div style={{ borderRadius: "50%", position: "relative" }}>
                        <img
                          src={formData.image}
                          height={"48px"}
                          width={"48px"}
                          alt={"new"}
                          style={{ borderRadius: "1rem" }}
                        />
                        <div
                          style={{
                            background: "antiquewhite",
                            borderRadius: "50%",
                            width: "fit-content",
                            paddingInline: "2px",
                            position: "absolute",
                            bottom: "0px",
                            right: "0",
                          }}
                        >
                          <img
                            src={penImage}
                            height={"15px"}
                            width={"15px"}
                            alt={"new"}
                            style={{ borderRadius: "1rem" }}
                          />
                        </div>
                      </div>
                    ) : (
                      props.contact.image && (
                        <div style={{ borderRadius: "50%", position: "relative" }}>
                          <img
                            src={props.contact.image}
                            height={"48px"}
                            width={"48px"}
                            alt={"Image"}
                            style={{ borderRadius: "1rem" }}
                          />
                          <div
                            style={{
                              background: "antiquewhite",
                              borderRadius: "50%",
                              width: "fit-content",
                              paddingInline: "2px",
                              position: "absolute",
                              bottom: "0px",
                              right: "0",
                            }}
                          >
                            <img
                              src={penImage}
                              height={"15px"}
                              width={"15px"}
                              alt={"Image"}
                              style={{ borderRadius: "1rem" }}
                            />
                          </div>
                        </div>
                      )
                    )}
                  </React.Fragment>
                ) : (
                  <div style={{ position: "relative" }}>
                    <div className="contactLogo">
                      {/* item.name.charAt(0).toUpperCase() */}
                      {props.contact.name
                        ? props.contact.name
                            .split(" ")
                            .map((part) => part[0])
                            .join("")
                        : "N/A"}
                    </div>
                    <div
                      style={{
                        background: "antiquewhite",
                        borderRadius: "50%",
                        width: "fit-content",
                        paddingInline: "2px",
                        position: "absolute",
                        bottom: "0px",
                        right: "0",
                      }}
                    >
                      <img
                        src={penImage}
                        height={"15px"}
                        width={"15px"}
                        alt={"Image"}
                        style={{ borderRadius: "1rem" }}
                      />
                    </div>
                  </div>
                )}
              </label>
              <div className="chatCardDesc">
                <span className="chatName">{props.contact.name ? props.contact.name : "N/A"}</span>
                <span className="chatValue" style={{}}>
                  {props.contact.phoneNumber ? props.contact.phoneNumber : "N/A"}
                </span>
              </div>
            </div>
          </div>
        </div>
        <div style={{ padding: "2rem" }}>
          <div>
            <div className="infocardrow" style={{ width: "100%" }}>
              <div className="infocardrowData">
                <span className="infocardsubTitle">
                  <label
                    className="labelStyleCheckout"
                    style={{
                      display: "inline-grid",
                      width: "100%",
                      marginTop: "4px",
                    }}
                  >
                    <h3
                      style={{
                        color: "#4d5e80",
                        marginBottom: "10px",
                        fontSize: "14px",
                        fontFamily: "Poppins",
                        lineHeight: "20px",
                        fontWeight: "700",
                      }}
                    >
                      {" "}
                      PreFix{" "}
                    </h3>
                    <div className="inputStyleCheckoutPromo" style={{ display: "flex" }}>
                      <input
                        name="prefix"
                        placeholder="Enter PreFix"
                        type="text"
                        className="inputStylepromo"
                        value={formData && formData.prefix}
                        onChange={(e) => {
                          e.preventDefault();
                          handlechange(e.target.name, e.target.value);
                        }}
                        style={{ width: "100%" }}
                        // onChange={handlePromotionCodeChange}
                      />
                    </div>
                  </label>
                </span>
              </div>
              <div className="infocardrowData">
                <span className="infocardsubTitle">
                  <label
                    className="labelStyleCheckout"
                    style={{
                      display: "inline-grid",
                      width: "100%",
                      marginTop: "4px",
                    }}
                  >
                    <h3
                      style={{
                        color: "#4d5e80",
                        marginBottom: "10px",
                        fontSize: "14px",
                        fontFamily: "Poppins",
                        lineHeight: "20px",
                        fontWeight: "700",
                      }}
                    >
                      {" "}
                      First Name <span style={{ color: "red" }}>*</span>
                    </h3>
                    <div className="inputStyleCheckoutPromo" style={{ display: "flex" }}>
                      <input
                        name="firstName"
                        placeholder="Enter First Name"
                        type="text"
                        className="inputStylepromo"
                        value={formData && formData.firstName}
                        onChange={(e) => {
                          e.preventDefault();
                          handlechange(e.target.name, e.target.value);
                        }}
                        style={{ width: "100%" }}
                        // onChange={handlePromotionCodeChange}
                      />
                    </div>
                  </label>
                </span>
              </div>
              <div className="infocardrowData">
                <span className="infocardsubTitle">
                  <label
                    className="labelStyleCheckout"
                    style={{
                      display: "inline-grid",
                      width: "100%",
                      marginTop: "4px",
                    }}
                  >
                    <h3
                      style={{
                        color: "#4d5e80",
                        marginBottom: "10px",
                        fontSize: "14px",
                        fontFamily: "Poppins",
                        lineHeight: "20px",
                        fontWeight: "700",
                      }}
                    >
                      {" "}
                      Last Name <span style={{ color: "red" }}>*</span>
                    </h3>
                    <div className="inputStyleCheckoutPromo" style={{ display: "flex" }}>
                      <input
                        name="lastName"
                        placeholder="Enter Last Name"
                        type="text"
                        className="inputStylepromo"
                        value={formData && formData.lastName}
                        onChange={(e) => {
                          e.preventDefault();
                          handlechange(e.target.name, e.target.value);
                        }}
                        style={{ width: "100%" }}
                        // onChange={handlePromotionCodeChange}
                      />
                    </div>
                  </label>
                </span>
              </div>
              <div className="infocardrowData">
                <span className="infocardsubTitle">
                  <label
                    className="labelStyleCheckout"
                    style={{
                      display: "inline-grid",
                      width: "100%",
                      marginTop: "4px",
                    }}
                  >
                    <h3
                      style={{
                        color: "#4d5e80",
                        marginBottom: "10px",
                        fontSize: "14px",
                        fontFamily: "Poppins",
                        lineHeight: "20px",
                        fontWeight: "700",
                      }}
                    >
                      {" "}
                      Suffix{" "}
                    </h3>
                    <div className="inputStyleCheckoutPromo" style={{ display: "flex" }}>
                      <input
                        name="suffix"
                        placeholder="Enter Suffix"
                        type="text"
                        className="inputStylepromo"
                        value={formData && formData.suffix}
                        onChange={(e) => {
                          e.preventDefault();
                          handlechange(e.target.name, e.target.value);
                        }}
                        style={{ width: "100%" }}
                        // onChange={handlePromotionCodeChange}
                      />
                    </div>
                  </label>
                </span>
              </div>
            </div>
            <div className="infocardrow" style={{ width: "100%" }}>
              <div className="infocardrowData">
                <span
                  className="infocardTitle1"
                  style={{
                    color: "black",
                    fontWeight: "bold",
                    fontSize: "14px",
                  }}
                >
                  {" "}
                  Job
                </span>
                <div
                  className="inputStyleCheckoutPromo"
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "1rem",
                  }}
                >
                  <input
                    name="jobCompany"
                    placeholder="Enter New Company"
                    className="inputStylepromo"
                    style={{ width: "100%" }}
                    value={formData && formData.jobCompany}
                    onChange={(e) => {
                      e.preventDefault();
                      handlechange(e.target.name, e.target.value);
                    }}
                    // onChange={handlePromotionCodeChange}
                  />
                  <input
                    name="jobDepartment"
                    placeholder="Enter New Department"
                    className="inputStylepromo"
                    style={{ width: "100%" }}
                    value={formData && formData.jobDepartment}
                    onChange={(e) => {
                      e.preventDefault();
                      handlechange(e.target.name, e.target.value);
                    }}
                    // onChange={handlePromotionCodeChange}
                  />
                  <input
                    name="jobTitle"
                    placeholder="Enter New Title"
                    className="inputStylepromo"
                    style={{ width: "100%" }}
                    value={formData && formData.jobTitle}
                    onChange={(e) => {
                      e.preventDefault();
                      handlechange(e.target.name, e.target.value);
                    }}
                    // onChange={handlePromotionCodeChange}
                  />
                  <button
                    className="savebutton"
                    style={{
                      textAlign: "center",
                      fontSize: "12px",
                      fontWeight: "600",
                      padding: "10px 10px",
                      width: "100%",
                      display: "flex",
                      alignItems: "center",
                    }}
                    type="submit"
                    onClick={() => {
                      addCloudContact();
                    }}
                  >
                    Add
                  </button>
                </div>
              </div>
              <div className="infocardrowData">
                <span
                  className="infocardTitle1"
                  style={{
                    color: "black",
                    fontWeight: "bold",
                    fontSize: "14px",
                  }}
                >
                  {" "}
                  Phone Number{" "}
                </span>
                <span className="infocardsubTitle">
                  <label
                    className="labelStyleCheckout"
                    style={{
                      display: "inline-grid",
                      width: "100%",
                      marginTop: "4px",
                    }}
                  >
                    <h3
                      style={{
                        color: "#4d5e80",
                        marginBottom: "10px",
                        fontSize: "14px",
                        fontFamily: "Poppins",
                        lineHeight: "20px",
                        fontWeight: "700",
                      }}
                    >
                      {" "}
                      Work{" "}
                    </h3>
                    <div className="inputStyleCheckoutPromo" style={{ display: "flex" }}>
                      <PhoneNumber
                        name="secondNumber"
                        value={formData && formData.secondNumber}
                        onChange={(e) => {
                          // e.preventDefault();
                          handlechange("secondNumber", e.target.value);
                        }}
                        style={{ width: "100%" }}
                        size="large"
                        placeholder="Phone"
                      ></PhoneNumber>
                      {/* <input
                        name="secondNumber"
                        placeholder="Phone"
                        className="inputStylepromo"
                        style={{ width: "100%" }}
                        value={formData && formData.secondNumber}
                        onChange={(e) => {
                          e.preventDefault();
                          handlechange(e.target.name, e.target.value);
                        }}
                      /> */}
                    </div>
                    <h3
                      style={{
                        color: "#4d5e80",
                        marginBottom: "10px",
                        fontSize: "14px",
                        fontFamily: "Poppins",
                        lineHeight: "20px",
                        fontWeight: "700",
                      }}
                    >
                      {" "}
                      Home <span style={{ color: "red" }}>*</span>
                    </h3>
                    <div className="inputStyleCheckoutPromo" style={{ display: "flex" }}>
                      <PhoneNumber
                        name="phoneNumber"
                        value={formData && formData.phoneNumber}
                        onChange={(e) => {
                          // e.preventDefault();
                          handlechange("phoneNumber", e.target.value);
                        }}
                        style={{ width: "100%" }}
                        size="large"
                        placeholder="Phone"
                      ></PhoneNumber>
                      {/* <input
                        name="phoneNumber"
                        placeholder="Phone"
                        className="inputStylepromo"
                        style={{ width: "100%" }}
                        value={formData && formData.phoneNumber}
                        onChange={(e) => {
                          e.preventDefault();
                          handlechange(e.target.name, e.target.value);
                        }}
                      /> */}
                    </div>
                    {props.contact &&
                      props.contact.cloud_contact_details &&
                      props.contact.cloud_contact_details.length > 0 &&
                      props.contact.cloud_contact_details.some((detail) => detail.heading === "Phone") &&
                      props.contact.cloud_contact_details.map((detail, index) => {
                        if (detail.heading === "Phone") {
                          // Find the existing dynamic detail in formData.dynamicDetails
                          const existingDetail =
                            formData &&
                            formData.dynamicDetails &&
                            formData.dynamicDetails.find(
                              (d) => d.heading === "Phone" && d.fieldName === detail.fieldName
                            );
                          // Set the value based on the existing detail, if found
                          const value = existingDetail ? existingDetail.fieldValue : detail.fieldValue;
                          return (
                            <div key={index} className="inputStyleCheckoutPromo">
                              {detail.fieldName}
                              {/*  <input
                                name="phone"
                                placeholder="phone"
                                type="text"
                                className="inputStylepromo"
                                value={value}
                                onChange={(e) => {
                                  e.preventDefault();
                                  handleDynamicChange("Phone", detail.fieldName, e.target.value);
                                }}
                                style={{ width: "100%" }}
                              /> */}
                              <PhoneNumber
                                name="phone"
                                value={value}
                                onChange={(e) => {
                                  // e.preventDefault();
                                  handleDynamicChange("Phone", detail.fieldName, e.target.value);
                                }}
                                style={{ width: "100%" }}
                                size="large"
                                placeholder="Phone"
                              ></PhoneNumber>
                            </div>
                          );
                        }
                        return null;
                      })}

                    <div id="additionalEmailFields">
                      {/* Additional phone fields */}
                      {phoneField.phone.map((phone, index) => (
                        <div key={index}>
                          <div
                            style={{
                              display: "flex",
                              justifyContent: "space-between",
                              alignItems: "center",
                              width: "90%",
                            }}
                          >
                            <h3
                              style={{
                                color: "#4d5e80",
                                marginBottom: "10px",
                                fontSize: "14px",
                                fontFamily: "Poppins",
                                lineHeight: "20px",
                                fontWeight: "700",
                              }}
                            >
                              {phone && phone.fieldName}
                            </h3>
                            <div style={{ cursor: "pointer" }} onClick={() => removePhoneField(index)}>
                              ❌
                            </div>
                          </div>
                          <div className="inputStyleCheckoutPromo">
                            <input
                              name={`fieldName${index}`}
                              placeholder="Enter Title"
                              type="text"
                              className="inputStylepromo"
                              value={phone.fieldName}
                              onChange={(e) => handlePhoneChange(index, "fieldName", e.target.value)}
                              style={{ width: "100%", marginBottom: "8px" }}
                            />
                            {/* <input
                            name={`fieldValue${index}`}
                            placeholder="Enter Value"
                            type="email"
                            className="inputStylepromo"
                            value={phone.fieldValue}
                            onChange={(e) => handlePhoneChange(index, 'fieldValue', e.target.value)}
                            style={{ width: "100%" }}
                          /> */}
                            <PhoneNumber
                              name={`fieldValue${index}`}
                              value={phone.fieldValue}
                              onChange={(e) => {
                                // e.preventDefault();
                                handlePhoneChange(index, "fieldValue", e.target.value);
                              }}
                              style={{ width: "100%" }}
                              size="large"
                              placeholder="Phone"
                            ></PhoneNumber>
                          </div>
                        </div>
                      ))}
                    </div>
                  </label>
                </span>
                <button
                  className="savebutton"
                  style={{
                    textAlign: "center",
                    fontSize: "12px",
                    fontWeight: "600",
                    padding: "10px 10px",
                    width: "90%",
                    display: "flex",
                    alignItems: "center",
                  }}
                  type="submit"
                  onClick={() => {
                    addPhoneField();
                  }}
                >
                  Add
                </button>
              </div>
            </div>
            <div className="infocardrow" style={{ width: "100%" }}>
              <div className="infocardrowData">
                <span
                  className="infocardTitle1"
                  style={{
                    color: "black",
                    fontWeight: "bold",
                    fontSize: "14px",
                  }}
                >
                  {" "}
                  Address
                </span>
                <span className="infocardsubTitle">
                  <label
                    className="labelStyleCheckout"
                    style={{
                      display: "inline-grid",
                      width: "100%",
                      marginTop: "4px",
                    }}
                  >
                    <h3
                      style={{
                        color: "#4d5e80",
                        marginBottom: "10px",
                        fontSize: "14px",
                        fontFamily: "Poppins",
                        lineHeight: "20px",
                        fontWeight: "700",
                      }}
                    >
                      {" "}
                      Work{" "}
                    </h3>
                    <div
                      className="inputStyleCheckoutPromo"
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        gap: "0.5rem",
                      }}
                    >
                      <input
                        name="workStreet"
                        placeholder="Enter Street"
                        type="text"
                        className="inputStylepromo"
                        style={{ width: "100%" }}
                        value={formData && formData.workStreet}
                        onChange={(e) => {
                          e.preventDefault();
                          handlechange(e.target.name, e.target.value);
                        }}
                      />
                      <input
                        name="secondWorkStreet"
                        placeholder="Enter Street 2"
                        type="text"
                        className="inputStylepromo"
                        style={{ width: "100%" }}
                        value={formData && formData.secondWorkStreet}
                        onChange={(e) => {
                          e.preventDefault();
                          handlechange(e.target.name, e.target.value);
                        }}
                        // onChange={handlePromotionCodeChange}
                      />
                      <input
                        name="workCity"
                        placeholder="Enter City"
                        type="text"
                        className="inputStylepromo"
                        style={{ width: "100%" }}
                        value={formData && formData.workCity}
                        onChange={(e) => {
                          e.preventDefault();
                          handlechange(e.target.name, e.target.value);
                        }}
                      />
                      <input
                        name="workState"
                        placeholder="Enter State"
                        type="text"
                        className="inputStylepromo"
                        style={{ width: "100%" }}
                        value={formData && formData.workState}
                        onChange={(e) => {
                          e.preventDefault();
                          handlechange(e.target.name, e.target.value);
                        }}
                      />
                      <input
                        name="workZip"
                        placeholder="Enter Zip"
                        type="text"
                        className="inputStylepromo"
                        style={{ width: "100%" }}
                        value={formData && formData.workZip}
                        onChange={(e) => {
                          e.preventDefault();
                          handlechange(e.target.name, e.target.value);
                        }}
                      />
                    </div>
                    <h3
                      style={{
                        color: "#4d5e80",
                        marginBottom: "10px",
                        fontSize: "14px",
                        fontFamily: "Poppins",
                        lineHeight: "20px",
                        fontWeight: "700",
                      }}
                    >
                      {" "}
                      Home{" "}
                    </h3>
                    <div
                      className="inputStyleCheckoutPromo"
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        gap: "0.5rem",
                      }}
                    >
                      <input
                        name="homeStreet"
                        placeholder="Enter Street"
                        type="text"
                        className="inputStylepromo"
                        style={{ width: "100%" }}
                        value={formData && formData.homeStreet}
                        onChange={(e) => {
                          e.preventDefault();
                          handlechange(e.target.name, e.target.value);
                        }}
                      />
                      <input
                        name="secondHomeStreet"
                        placeholder="Enter Street 2"
                        type="text"
                        className="inputStylepromo"
                        style={{ width: "100%" }}
                        value={formData && formData.secondHomeStreet}
                        onChange={(e) => {
                          e.preventDefault();
                          handlechange(e.target.name, e.target.value);
                        }}
                      />
                      <input
                        name="homeCity"
                        placeholder="Enter City"
                        type="text"
                        className="inputStylepromo"
                        style={{ width: "100%" }}
                        value={formData && formData.homeCity}
                        onChange={(e) => {
                          e.preventDefault();
                          handlechange(e.target.name, e.target.value);
                        }}
                      />
                      <input
                        name="homeState"
                        placeholder="Enter State"
                        type="text"
                        className="inputStylepromo"
                        style={{ width: "100%" }}
                        value={formData && formData.homeState}
                        onChange={(e) => {
                          e.preventDefault();
                          handlechange(e.target.name, e.target.value);
                        }}
                      />
                      <input
                        name="homeZip"
                        placeholder="Enter Zip"
                        type="text"
                        className="inputStylepromo"
                        style={{ width: "100%" }}
                        value={formData && formData.homeZip}
                        onChange={(e) => {
                          e.preventDefault();
                          handlechange(e.target.name, e.target.value);
                        }}
                      />
                    </div>

                    {props.contact &&
                      props.contact.cloud_contact_details &&
                      props.contact.cloud_contact_details.length > 0 &&
                      Object.entries(
                        props.contact.cloud_contact_details.reduce((acc, detail) => {
                          if (detail.heading === "Address" && detail.fieldName !== "fieldName") {
                            // Add condition here
                            acc[detail.fieldSubType] = acc[detail.fieldSubType] || [];
                            acc[detail.fieldSubType].push(detail);
                          }
                          return acc;
                        }, {})
                      ).map(([subType, inputFields]) => (
                        <div key={subType}>
                          <h3
                            style={{
                              color: "#4d5e80",
                              marginBottom: "10px",
                              fontSize: "14px",
                              fontFamily: "Poppins",
                              lineHeight: "20px",
                              fontWeight: "700",
                            }}
                          >
                            {subType}
                          </h3>
                          {inputFields.map((inputDetail, index) => (
                            <div key={index} className="inputStyleCheckoutPromo">
                              {inputDetail.fieldName}
                              <input
                                name={inputDetail.fieldName}
                                placeholder={inputDetail.fieldName}
                                type="text"
                                className="inputStylepromo"
                                value={inputDetail.fieldValue}
                                onChange={(e) => {
                                  e.preventDefault();
                                  inputDetail.fieldValue = e.target.value;
                                  handleDynamicAddressChange(
                                    "Address",
                                    subType,
                                    inputDetail.fieldName,
                                    e.target.value
                                  );
                                }}
                                style={{ width: "100%" }}
                              />
                            </div>
                          ))}
                        </div>
                      ))}

                    <div id="additionalEmailFields">
                      {/* Additional address fields */}
                      {console.log("addressFiled", addressField)}
                      {addressField.address.map((address, index) => (
                        <div key={index}>
                          <div
                            style={{
                              display: "flex",
                              justifyContent: "space-between",
                              alignItems: "center",
                              width: "90%",
                            }}
                          >
                            <h3
                              style={{
                                color: "#4d5e80",
                                marginBottom: "10px",
                                fontSize: "14px",
                                fontFamily: "Poppins",
                                lineHeight: "20px",
                                fontWeight: "700",
                              }}
                            >
                              {address && address.fieldName}
                            </h3>
                            <div style={{ cursor: "pointer" }} onClick={() => removeAddressField(index)}>
                              ❌
                            </div>
                          </div>
                          <div className="inputStyleCheckoutPromo">
                            <input
                              name={`fieldName${index}`}
                              placeholder="Enter Title"
                              type="text"
                              className="inputStylepromo"
                              value={address.fieldName}
                              onChange={(e) => handleAddressChange(index, "fieldName", e.target.value)}
                              style={{ width: "100%", marginBottom: "8px" }}
                            />
                            <input
                              name={`street${index}`} // Use unique names for each field
                              placeholder="Enter Street"
                              type="text"
                              className="inputStylepromo"
                              value={address.street} // Assuming street is the fieldName for street
                              onChange={(e) => handleAddressChange(index, "street", e.target.value)} // Update handleAddressChange accordingly
                              style={{ width: "100%", marginBottom: "8px" }}
                            />
                            <input
                              name={`street2${index}`}
                              placeholder="Enter Street2"
                              type="text"
                              className="inputStylepromo"
                              value={address.street2}
                              onChange={(e) => handleAddressChange(index, "street2", e.target.value)}
                              style={{ width: "100%", marginBottom: "8px" }}
                            />
                            <input
                              name={`city${index}`}
                              placeholder="Enter City"
                              type="text"
                              className="inputStylepromo"
                              value={address.city}
                              onChange={(e) => handleAddressChange(index, "city", e.target.value)}
                              style={{ width: "100%", marginBottom: "8px" }}
                            />
                            <input
                              name={`state${index}`}
                              placeholder="Enter State"
                              type="text"
                              className="inputStylepromo"
                              value={address.state}
                              onChange={(e) => handleAddressChange(index, "state", e.target.value)}
                              style={{ width: "100%", marginBottom: "8px" }}
                            />
                            <input
                              name={`zip${index}`}
                              placeholder="Enter Zip"
                              type="text"
                              className="inputStylepromo"
                              value={address.zip}
                              onChange={(e) => handleAddressChange(index, "zip", e.target.value)}
                              style={{ width: "100%", marginBottom: "8px" }}
                            />
                          </div>
                        </div>
                      ))}
                    </div>
                  </label>
                </span>
                <button
                  className="savebutton"
                  style={{
                    textAlign: "center",
                    fontSize: "12px",
                    fontWeight: "600",
                    padding: "10px 10px",
                    width: "90%",
                    display: "flex",
                    alignItems: "center",
                  }}
                  type="submit"
                  onClick={() => {
                    addAddressField();
                  }}
                >
                  Add
                </button>
              </div>
              <div className="infocardrowData">
                <span
                  className="infocardTitle1"
                  style={{
                    color: "black",
                    fontWeight: "bold",
                    fontSize: "14px",
                  }}
                >
                  {" "}
                  Group{" "}
                </span>
                <span className="infocardsubTitle">
                  <div
                    className="labelStyleCheckout"
                    style={{
                      display: "inline-grid",
                      width: "100%",
                      marginTop: "4px",
                    }}
                  >
                    <h3
                      style={{
                        // color: "#4d5e80",
                        marginBottom: "10px",
                        fontSize: "14px",
                        fontFamily: "Poppins",
                        lineHeight: "20px",
                        fontWeight: "700",
                      }}
                    >
                      {" "}
                      Group{" "}
                    </h3>
                    <div
                      className="inputStyleCheckoutPromo"
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        gap: "1rem",
                      }}
                    >
                      {console.log("groupsss", groups && groups !== null && groups)}
                      <Select
                        showSearch
                        placeholder="-Select-"
                        mode="tags"
                        value={groups && groups !== null && groups}
                        onChange={(value, id) => {
                          console.log("value", value, id);
                          setGroups(value);
                        }}
                      >
                        {props.groups &&
                          props.groups.map((item, index) => (
                            <Option key={index} value={item.name}>
                              {item.name}
                            </Option>
                          ))}
                      </Select>

                      <button
                        className="savebutton"
                        style={{
                          textAlign: "center",
                          fontSize: "12px",
                          fontWeight: "600",
                          padding: "10px 10px",
                          width: "100%",
                          display: "flex",
                          alignItems: "center",
                        }}
                        type="submit"
                        onClick={() => {
                          addGroupCloudContact();
                        }}
                      >
                        Add
                      </button>
                    </div>
                    <h3
                      style={{
                        // color: "#4d5e80",
                        marginBottom: "10px",
                        fontSize: "14px",
                        fontFamily: "Poppins",
                        lineHeight: "20px",
                        fontWeight: "700",
                      }}
                    >
                      {" "}
                      Email{" "}
                    </h3>
                    <span className="infocardsubTitle">
                      <label
                        className="labelStyleCheckout"
                        style={{
                          display: "inline-grid",
                          width: "100%",
                          marginTop: "4px",
                        }}
                      >
                        <h3
                          style={{
                            color: "#4d5e80",
                            marginBottom: "10px",
                            fontSize: "14px",
                            fontFamily: "Poppins",
                            lineHeight: "20px",
                            fontWeight: "700",
                          }}
                        >
                          {" "}
                          Work{" "}
                        </h3>
                        <div className="inputStyleCheckoutPromo" style={{ display: "flex" }}>
                          <input
                            name="secondEmail"
                            placeholder="Email"
                            type="email"
                            className="inputStylepromo"
                            value={formData && formData.secondEmail}
                            onChange={(e) => {
                              e.preventDefault();
                              handlechange(e.target.name, e.target.value);
                            }}
                            style={{ width: "100%" }}
                            // onChange={handlePromotionCodeChange}
                          />
                        </div>
                        <h3
                          style={{
                            color: "#4d5e80",
                            marginBottom: "10px",
                            fontSize: "14px",
                            fontFamily: "Poppins",
                            lineHeight: "20px",
                            fontWeight: "700",
                          }}
                        >
                          {" "}
                          Home <span style={{ color: "red" }}>*</span>
                        </h3>
                        <div className="inputStyleCheckoutPromo" style={{ display: "flex" }}>
                          <input
                            name="email"
                            placeholder="Email"
                            type="email"
                            className="inputStylepromo"
                            value={formData && formData.email}
                            onChange={(e) => {
                              e.preventDefault();
                              handlechange(e.target.name, e.target.value);
                            }}
                            style={{ width: "100%" }}
                          />
                        </div>
                        {props.contact &&
                          props.contact.cloud_contact_details &&
                          props.contact.cloud_contact_details.length > 0 &&
                          props.contact.cloud_contact_details.some((detail) => detail.heading === "Email") &&
                          props.contact.cloud_contact_details.map((detail, index) => {
                            if (detail.heading === "Email") {
                              // Find the existing dynamic detail in formData.dynamicDetails
                              const existingDetail =
                                formData &&
                                formData.dynamicDetails &&
                                formData.dynamicDetails.find(
                                  (d) => d.heading === "Email" && d.fieldName === detail.fieldName
                                );
                              // Set the value based on the existing detail, if found
                              const value = existingDetail ? existingDetail.fieldValue : detail.fieldValue;
                              return (
                                <div key={index} className="inputStyleCheckoutPromo">
                                  {detail.fieldName}
                                  <input
                                    name="email"
                                    placeholder="Email"
                                    type="email"
                                    className="inputStylepromo"
                                    value={value}
                                    onChange={(e) => {
                                      e.preventDefault();
                                      handleDynamicChange("Email", detail.fieldName, e.target.value);
                                    }}
                                    style={{ width: "100%" }}
                                  />
                                </div>
                              );
                            }
                            return null;
                          })}

                        <div id="additionalEmailFields">
                          {/* Additional email fields */}
                          {emailsField.emails.map((email, index) => (
                            <div key={index}>
                              <div
                                style={{
                                  display: "flex",
                                  justifyContent: "space-between",
                                  alignItems: "center",
                                  width: "90%",
                                }}
                              >
                                <h3
                                  style={{
                                    color: "#4d5e80",
                                    marginBottom: "10px",
                                    fontSize: "14px",
                                    fontFamily: "Poppins",
                                    lineHeight: "20px",
                                    fontWeight: "700",
                                  }}
                                >
                                  {email && email.fieldName}
                                </h3>
                                <div style={{ cursor: "pointer" }} onClick={() => removeEmailField(index)}>
                                  ❌
                                </div>
                              </div>
                              <div className="inputStyleCheckoutPromo">
                                <input
                                  name={`fieldName${index}`}
                                  placeholder="Enter Title"
                                  type="text"
                                  className="inputStylepromo"
                                  value={email.fieldName}
                                  onChange={(e) => handleEmailsChange(index, "fieldName", e.target.value)}
                                  style={{ width: "100%", marginBottom: "8px" }}
                                />
                                <input
                                  name={`fieldValue${index}`}
                                  placeholder="Enter Value"
                                  type="email"
                                  className="inputStylepromo"
                                  value={email.fieldValue}
                                  onChange={(e) => handleEmailsChange(index, "fieldValue", e.target.value)}
                                  style={{ width: "100%" }}
                                />
                              </div>
                            </div>
                          ))}
                        </div>
                      </label>
                    </span>
                    <button
                      className="savebutton"
                      style={{
                        textAlign: "center",
                        fontSize: "12px",
                        fontWeight: "600",
                        padding: "10px 10px",
                        width: "90%",
                        display: "flex",
                        alignItems: "center",
                      }}
                      type="submit"
                      onClick={() => {
                        addEmailField();
                      }}
                    >
                      Add
                    </button>
                    <h3
                      style={{
                        // color: "#4d5e80",
                        marginBottom: "10px",
                        fontSize: "14px",
                        fontFamily: "Poppins",
                        lineHeight: "20px",
                        fontWeight: "700",
                      }}
                    >
                      {" "}
                      Social Profile{" "}
                    </h3>
                    <div
                      className="inputStyleCheckoutPromo"
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        gap: "1rem",
                      }}
                    >
                      <input
                        name="socialProfiles"
                        placeholder="Enter Social Profile"
                        className="inputStylepromo"
                        style={{ width: "100%" }}
                        value={formData && formData.socialProfiles}
                        onChange={(e) => {
                          e.preventDefault();
                          handlechange(e.target.name, e.target.value);
                        }}
                        // onChange={handlePromotionCodeChange}
                      />
                      {props.contact &&
                        props.contact.cloud_contact_details &&
                        props.contact.cloud_contact_details.length > 0 &&
                        props.contact.cloud_contact_details.some((detail) => detail.heading === "Social") &&
                        props.contact.cloud_contact_details.map((detail, index) => {
                          if (detail.heading === "Social") {
                            // Find the existing dynamic detail in formData.dynamicDetails
                            const existingDetail =
                              formData &&
                              formData.dynamicDetails &&
                              formData.dynamicDetails.find(
                                (d) => d.heading === "Social" && d.fieldName === detail.fieldName
                              );
                            // Set the value based on the existing detail, if found
                            const value = existingDetail ? existingDetail.fieldValue : detail.fieldValue;
                            return (
                              <div key={index} className="inputStyleCheckoutPromo">
                                {detail.fieldName}
                                <input
                                  name="Social"
                                  placeholder="Social"
                                  type="text"
                                  className="inputStylepromo"
                                  value={value}
                                  onChange={(e) => {
                                    e.preventDefault();
                                    handleDynamicChange("Social", detail.fieldName, e.target.value);
                                  }}
                                  style={{ width: "100%" }}
                                />
                              </div>
                            );
                          }
                          return null;
                        })}

                      <div id="additionalEmailFields">
                        {/* Additional email fields */}
                        {socialField.social.map((social, index) => (
                          <div key={index}>
                            <div
                              style={{
                                display: "flex",
                                justifyContent: "space-between",
                                alignItems: "center",
                                width: "90%",
                              }}
                            >
                              <h3
                                style={{
                                  color: "#4d5e80",
                                  marginBottom: "10px",
                                  fontSize: "14px",
                                  fontFamily: "Poppins",
                                  lineHeight: "20px",
                                  fontWeight: "700",
                                }}
                              >
                                {social && social.fieldName}
                              </h3>
                              <div style={{ cursor: "pointer" }} onClick={() => removeSocialField(index)}>
                                ❌
                              </div>
                            </div>
                            <div className="inputStyleCheckoutPromo">
                              <input
                                name={`fieldName${index}`}
                                placeholder="Enter Title"
                                type="text"
                                className="inputStylepromo"
                                value={social.fieldName}
                                onChange={(e) => handleSocialChange(index, "fieldName", e.target.value)}
                                style={{ width: "100%", marginBottom: "8px" }}
                              />
                              <input
                                name={`fieldValue${index}`}
                                placeholder="Enter Value"
                                type="text"
                                className="inputStylepromo"
                                value={social.fieldValue}
                                onChange={(e) => handleSocialChange(index, "fieldValue", e.target.value)}
                                style={{ width: "100%" }}
                              />
                            </div>
                          </div>
                        ))}
                      </div>
                      <button
                        className="savebutton"
                        style={{
                          textAlign: "center",
                          fontSize: "12px",
                          fontWeight: "600",
                          padding: "10px 10px",
                          width: "100%",
                          display: "flex",
                          alignItems: "center",
                        }}
                        type="submit"
                        onClick={() => {
                          addSocialField();
                        }}
                      >
                        Add
                      </button>
                    </div>
                  </div>
                </span>
              </div>
            </div>

            <div className="infocardrow2" style={{ width: "100%" }}>
              <div className="infocardrowData">
                <span
                  className="infocardTitle1"
                  style={{
                    color: "black",
                    fontWeight: "bold",
                    fontSize: "14px",
                  }}
                >
                  {" "}
                  Important Dates
                </span>
                <span className="infocardsubTitle">
                  <label
                    className="labelStyleCheckout"
                    style={{
                      display: "inline-grid",
                      width: "100%",
                      marginTop: "4px",
                    }}
                  >
                    <h3
                      style={{
                        color: "#4d5e80",
                        marginBottom: "10px",
                        fontSize: "14px",
                        fontFamily: "Poppins",
                        lineHeight: "20px",
                        fontWeight: "700",
                      }}
                    >
                      {" "}
                      Birthday{" "}
                    </h3>
                    <div
                      className="inputStyleCheckoutPromo"
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        gap: "0.5rem",
                        marginBottom: "8px",
                      }}
                    >
                      <input
                        name="birthday"
                        placeholder="Enter Birthday"
                        type="date"
                        className="inputStylepromo"
                        style={{ width: "100%" }}
                        value={formData && formData.birthday}
                        onChange={(e) => {
                          e.preventDefault();
                          handlechange(e.target.name, e.target.value);
                        }}
                        // onChange={handlePromotionCodeChange}
                      />
                    </div>
                    {props.contact &&
                      props.contact.cloud_contact_details &&
                      props.contact.cloud_contact_details.length > 0 &&
                      props.contact.cloud_contact_details.some((detail) => detail.heading === "Date") &&
                      props.contact.cloud_contact_details.map((detail, index) => {
                        if (detail.heading === "Date") {
                          // Find the existing dynamic detail in formData.dynamicDetails
                          const existingDetail =
                            formData &&
                            formData.dynamicDetails &&
                            formData.dynamicDetails.find(
                              (d) => d.heading === "Date" && d.fieldName === detail.fieldName
                            );
                          // Set the value based on the existing detail, if found
                          const value = existingDetail ? existingDetail.fieldValue : detail.fieldValue;
                          return (
                            <div
                              key={index}
                              className="inputStyleCheckoutPromo"
                              style={{ marginBottom: "4px" }}
                            >
                              {detail.fieldName}
                              <input
                                name="Date"
                                placeholder="Date"
                                type="Date"
                                className="inputStylepromo"
                                value={value}
                                onChange={(e) => {
                                  e.preventDefault();
                                  handleDynamicChange("Date", detail.fieldName, e.target.value);
                                }}
                                style={{ width: "100%" }}
                              />
                            </div>
                          );
                        }
                        return null;
                      })}
                    <div id="additionalEmailFields">
                      {/* Additional date fields */}
                      {dateField.date.map((date, index) => (
                        <div key={index}>
                          <div
                            style={{
                              display: "flex",
                              justifyContent: "space-between",
                              alignItems: "center",
                              width: "90%",
                            }}
                          >
                            <h3
                              style={{
                                color: "#4d5e80",
                                marginBottom: "10px",
                                fontSize: "14px",
                                fontFamily: "Poppins",
                                lineHeight: "20px",
                                fontWeight: "700",
                              }}
                            >
                              {date && date.fieldName}
                            </h3>
                            <div style={{ cursor: "pointer" }} onClick={() => removeDateField(index)}>
                              ❌
                            </div>
                          </div>
                          <div className="inputStyleCheckoutPromo" style={{ marginBottom: "4px" }}>
                            <input
                              name={`fieldName${index}`}
                              placeholder="Enter Title"
                              type="text"
                              className="inputStylepromo"
                              value={date.fieldName}
                              onChange={(e) => handleDateChange(index, "fieldName", e.target.value)}
                              style={{ width: "100%", marginBottom: "8px" }}
                            />
                            <input
                              name={`fieldValue${index}`}
                              placeholder="Enter Value"
                              type="date"
                              className="inputStylepromo"
                              value={date.fieldValue}
                              onChange={(e) => handleDateChange(index, "fieldValue", e.target.value)}
                              style={{ width: "100%" }}
                            />
                          </div>
                        </div>
                      ))}
                    </div>

                    <button
                      className="savebutton"
                      style={{
                        textAlign: "center",
                        fontSize: "12px",
                        fontWeight: "600",
                        padding: "10px 10px",
                        width: "100%",
                        display: "flex",
                        alignItems: "center",
                      }}
                      type="submit"
                      onClick={() => {
                        addDateField();
                      }}
                    >
                      Add
                    </button>
                  </label>
                </span>
              </div>
              <div className="infocardrowData">
                <span
                  className="infocardTitle1"
                  style={{
                    color: "black",
                    fontWeight: "bold",
                    fontSize: "14px",
                  }}
                >
                  {" "}
                  Webpage{" "}
                </span>
                <span className="infocardsubTitle">
                  <label
                    className="labelStyleCheckout"
                    style={{
                      display: "inline-grid",
                      width: "100%",
                      marginTop: "4px",
                    }}
                  >
                    <h3
                      style={{
                        // color: "#4d5e80",
                        marginBottom: "10px",
                        fontSize: "14px",
                        fontFamily: "Poppins",
                        lineHeight: "20px",
                        fontWeight: "700",
                      }}
                    >
                      {" "}
                      Work{" "}
                    </h3>
                    <div
                      className="inputStyleCheckoutPromo"
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        gap: "1rem",
                      }}
                    >
                      <input
                        name="workWebPage"
                        placeholder="Enter website"
                        className="inputStylepromo"
                        style={{ width: "100%" }}
                        value={formData && formData.workWebPage}
                        onChange={(e) => {
                          e.preventDefault();
                          handlechange(e.target.name, e.target.value);
                        }}
                        // onChange={handlePromotionCodeChange}
                      />
                    </div>
                    <h3
                      style={{
                        // color: "#4d5e80",
                        marginBottom: "10px",
                        fontSize: "14px",
                        fontFamily: "Poppins",
                        lineHeight: "20px",
                        fontWeight: "700",
                      }}
                    >
                      {" "}
                      Home{" "}
                    </h3>
                    <div
                      className="inputStyleCheckoutPromo"
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        gap: "1rem",
                      }}
                    >
                      <input
                        name="homeWebPage"
                        placeholder="Enter website"
                        className="inputStylepromo"
                        style={{ width: "100%" }}
                        value={formData && formData.homeWebPage}
                        onChange={(e) => {
                          e.preventDefault();
                          handlechange(e.target.name, e.target.value);
                        }}
                        // onChange={handlePromotionCodeChange}
                      />
                      {props.contact &&
                        props.contact.cloud_contact_details &&
                        props.contact.cloud_contact_details.length > 0 &&
                        props.contact.cloud_contact_details.some((detail) => detail.heading === "Web") &&
                        props.contact.cloud_contact_details.map((detail, index) => {
                          if (detail.heading === "Web") {
                            // Find the existing dynamic detail in formData.dynamicDetails
                            const existingDetail =
                              formData &&
                              formData.dynamicDetails &&
                              formData.dynamicDetails.find(
                                (d) => d.heading === "Web" && d.fieldName === detail.fieldName
                              );
                            // Set the value based on the existing detail, if found
                            const value = existingDetail ? existingDetail.fieldValue : detail.fieldValue;
                            return (
                              <div key={index} className="inputStyleCheckoutPromo">
                                {detail.fieldName}
                                <input
                                  name="Web"
                                  placeholder="Web"
                                  type="text"
                                  className="inputStylepromo"
                                  value={value}
                                  onChange={(e) => {
                                    e.preventDefault();
                                    handleDynamicChange("Web", detail.fieldName, e.target.value);
                                  }}
                                  style={{ width: "100%" }}
                                />
                              </div>
                            );
                          }
                          return null;
                        })}
                      <div id="additionalEmailFields">
                        {/* Additional email fields */}
                        {webField.web.map((web, index) => (
                          <div key={index}>
                            <div
                              style={{
                                display: "flex",
                                justifyContent: "space-between",
                                alignItems: "center",
                                width: "90%",
                              }}
                            >
                              <h3
                                style={{
                                  color: "#4d5e80",
                                  marginBottom: "10px",
                                  fontSize: "14px",
                                  fontFamily: "Poppins",
                                  lineHeight: "20px",
                                  fontWeight: "700",
                                }}
                              >
                                {web && web.fieldName}
                              </h3>
                              <div style={{ cursor: "pointer" }} onClick={() => removeWebField(index)}>
                                ❌
                              </div>
                            </div>
                            <div className="inputStyleCheckoutPromo">
                              <input
                                name={`fieldName${index}`}
                                placeholder="Enter Title"
                                type="text"
                                className="inputStylepromo"
                                value={web.fieldName}
                                onChange={(e) => handleWebChange(index, "fieldName", e.target.value)}
                                style={{ width: "100%", marginBottom: "8px" }}
                              />
                              <input
                                name={`fieldValue${index}`}
                                placeholder="Enter Value"
                                type="text"
                                className="inputStylepromo"
                                value={web.fieldValue}
                                onChange={(e) => handleWebChange(index, "fieldValue", e.target.value)}
                                style={{ width: "100%" }}
                              />
                            </div>
                          </div>
                        ))}
                      </div>
                      <button
                        className="savebutton"
                        style={{
                          textAlign: "center",
                          fontSize: "12px",
                          fontWeight: "600",
                          padding: "10px 10px",
                          width: "90%",
                          display: "flex",
                          alignItems: "center",
                        }}
                        type="submit"
                        onClick={() => {
                          addWebField();
                        }}
                      >
                        Add
                      </button>
                    </div>
                  </label>
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div style={{ display: "flex", justifyContent: "space-between", paddingInline: "2rem" }}>
        <span className="infocardsubTitle" style={{ width: "50%" }}>
          <label
            className="labelStyleCheckout"
            style={{
              display: "inline-grid",
              width: "100%",
              marginTop: "4px",
            }}
          >
            <h3
              style={{
                color: "#4d5e80",
                marginBottom: "10px",
                fontSize: "14px",
                fontFamily: "Poppins",
                lineHeight: "20px",
                fontWeight: "700",
              }}
            >
              {" "}
              Type of Relation{" "}
            </h3>
            <div
              className="inputStyleCheckoutPromo"
              style={{
                display: "flex",
                flexDirection: "column",
                gap: "0.5rem",
                marginBottom: "8px",
              }}
            >
              <Select
                showSearch
                placeholder="-Select-"
                value={formData && formData.typeOfRelation}
                onChange={(value, id) => {
                  console.log("value", value, id);
                  handlechange("typeOfRelation", value);
                  // setGroups(value);
                }}
              >
                {typeOfRelation &&
                  typeOfRelation.map((item, index) => (
                    <Option key={index} value={item}>
                      {item}
                    </Option>
                  ))}
              </Select>
            </div>
          </label>
        </span>
        <span className="infocardsubTitle" style={{ width: "50%" }}>
          <label
            className="labelStyleCheckout"
            style={{
              display: "inline-grid",
              width: "100%",
              marginTop: "4px",
            }}
          >
            <h3
              style={{
                color: "#4d5e80",
                marginBottom: "10px",
                fontSize: "14px",
                fontFamily: "Poppins",
                lineHeight: "20px",
                fontWeight: "700",
              }}
            >
              {" "}
              Note{" "}
            </h3>
            <div
              className="inputStyleCheckoutPromo"
              style={{
                display: "flex",
                flexDirection: "column",
                gap: "0.5rem",
                marginBottom: "8px",
              }}
            >
              <textarea
                className="inputFieldClass"
                style={{ width: "100%", padding: "5px" }}
                placeholder="Note"
                rows={1}
                value={formData && formData.note}
                onChange={(e) => {
                  e.preventDefault();
                  handlechange(e.target.name, e.target.value);
                }}
                name="note"
              />
            </div>
          </label>
        </span>
      </div>
      <div style={{ paddingInline: "2rem", fontWeight: "bold", color: "black" }}>
        Changes in these Fields will affects Death (When I Die) directly:
      </div>
      <div style={{ display: "flex", justifyContent: "space-between", paddingInline: "2rem" }}>
        <span className="infocardsubTitle" style={{ width: "33%" }}>
          <div
            className="labelStyleCheckout"
            style={{
              display: "inline-grid",
              width: "100%",
              marginTop: "4px",
            }}
          >
            <h3
              style={{
                color: "#4d5e80",
                marginBottom: "10px",
                fontSize: "14px",
                fontFamily: "Poppins",
                lineHeight: "20px",
                fontWeight: "700",
                display: "flex",
                alignItems: "baseline",
                columnGap: "3px",
              }}
            >
              {" "}
              Trusted Individual{" "}  <ToolTipCreator name="trusted_individual" />
            </h3>
            <div
              className="inputStyleCheckoutPromo"
              style={{
                display: "flex",
                flexDirection: "column",
                gap: "0.5rem",
                marginBottom: "8px",
              }}
            >
              <Radio.Group
                buttonStyle="solid"
                name="isTrusted"
                value={formData ? (formData.isTrusted ? "Yes" : "No") : ""}
                onChange={(e) => {
                  const selectedValue = e.target.value === "Yes" ? true : false;
                  handlechange(e.target.name, selectedValue);
                }}
              >
                {["Yes", "No"].map((value, vindex) => (
                  <Radio.Button key={vindex} value={value}>
                    {value}
                  </Radio.Button>
                ))}
              </Radio.Group>
            </div>
          </div>
        </span>
        <span className="infocardsubTitle" style={{ width: "33%" }}>
          <div
            className="labelStyleCheckout"
            style={{
              display: "inline-grid",
              width: "100%",
              marginTop: "4px",
            }}
          >
            <h3
              style={{
                color: "#4d5e80",
                marginBottom: "10px",
                fontSize: "14px",
                fontFamily: "Poppins",
                lineHeight: "20px",
                fontWeight: "700",
                display: "flex",
                alignItems: "baseline",
                columnGap: "3px",
              }}
            >
              {" "}
              Second Password Granted{" "}  <ToolTipCreator name="second_password_granted" />
            </h3>
            <div
              className="inputStyleCheckoutPromo"
              style={{
                display: "flex",
                flexDirection: "column",
                gap: "0.5rem",
                marginBottom: "8px",
              }}
            >
              <Radio.Group
                buttonStyle="solid"
                name="secondPasswordGranted"
                value={formData ? (formData.secondPasswordGranted ? "Yes" : "No") : ""}
                onChange={(e) => {
                  const selectedValue = e.target.value === "Yes" ? true : false;
                  handlechange(e.target.name, selectedValue);
                }}
              >
                {["Yes", "No"].map((value, vindex) => (
                  <Radio.Button key={vindex} value={value}>
                    {value}
                  </Radio.Button>
                ))}
              </Radio.Group>
            </div>
          </div>
        </span>
        <span className="infocardsubTitle" style={{ width: "33%" }}>
          <div
            className="labelStyleCheckout"
            style={{
              display: "inline-grid",
              width: "100%",
              marginTop: "4px",
            }}
          >
            <h3
              style={{
                color: "#4d5e80",
                marginBottom: "10px",
                fontSize: "14px",
                fontFamily: "Poppins",
                lineHeight: "20px",
                fontWeight: "700",
                display: "flex",
                alignItems: "baseline",
                columnGap: "3px",
              }}
            >
              {" "}
              Part Of Core Team{" "}  <ToolTipCreator name="part_of_core_team" />
            </h3>
            <div
              className="inputStyleCheckoutPromo"
              style={{
                display: "flex",
                flexDirection: "column",
                gap: "0.5rem",
                marginBottom: "8px",
              }}
            >
              <Radio.Group
                buttonStyle="solid"
                name="partOfCoreTeam"
                value={formData ? (formData.partOfCoreTeam ? "Yes" : "No") : ""}
                onChange={(e) => {
                  const selectedValue = e.target.value === "Yes" ? true : false;
                  handlechange(e.target.name, selectedValue);
                }}
              >
                {["Yes", "No"].map((value, vindex) => (
                  <Radio.Button key={vindex} value={value}>
                    {value}
                  </Radio.Button>
                ))}
              </Radio.Group>
            </div>
          </div>
        </span>
      </div>

      <div style={{ display: "flex", justifyContent: "space-between", marginTop: "1rem" }}>
        <button
          className="cancelbutton"
          onClick={() => {
            props.close();
          }}
        >
          Cancel
        </button>
        <button
          className="savebutton"
          style={{
            opacity:
              formData && formData.lastName && formData.firstName && formData.email && formData.phoneNumber
                ? "1"
                : "0.3",
            cursor:
              formData && formData.lastName && formData.firstName && formData.email && formData.phoneNumber
                ? "pointer"
                : "not-allowed",
            pointerEvents:
              formData && formData.lastName && formData.firstName && formData.email && formData.phoneNumber
                ? ""
                : "none",
          }}
          onClick={() => {
            updateCloudContact();
          }}
        >
          Save
        </button>
      </div>
      <Loader isLoading={loading} />
    </div>
  );
};
